module.exports = __webpack_public_path__ + "img/settings_edit_gateway.d45447b2.png";